import axios, { Method } from 'axios';
import { getAuth } from 'firebase/auth';

// `T = any` explicite : depuis axios 1.x, un générique non contraint se résout en
// `unknown`, ce qui casse tous les appelants qui lisent directement des propriétés
// sur la réponse. On restaure le comportement historique sans toucher aux appels.
export const makeAuthenticatedApiCall = async <T = any>(
  method: Method,
  url: string,
  data?: any,
  options?: { responseType: 'json' | 'blob' },
) => {
  const auth = getAuth();
  if (!auth.currentUser) {
    throw new Error('User not authenticated');
  }

  const token = await auth.currentUser.getIdToken();
  try {
    const response = await axios<T>({
      method,
      url,
      data,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: options?.responseType || 'json', // Utiliser la valeur du paramètre ou 'json' par défaut
    });
    return response;
  } catch (error) {
    console.error('Error making API call:', error);
    throw error;
  }
};
